module.exports = __webpack_public_path__ + "media/images/new-ui-images/logout-icon-c08054535c11bb0bfc92d557dfb47912.svg";